import { EnvironmentContext } from '../../UNSAFE_Environment';
import { useContext } from 'preact/hooks';

export type TestIdProps = {
  testId?: string;
};
/**
 * Returns the set of attributes to be applied to the DOM node if the application's mode is not
 * set to "production".
 */
export function useTestId(testId?: string) {
  const context = useContext(EnvironmentContext);
  return context.mode === 'production' || testId === ''
    ? {}
    : {
        'data-testid': testId
      };
}
